import React, { type FC, memo, useEffect, useState } from "react";
import styled from "styled-components";
import { useIsMobile } from "../../../hooks/customDeviceDetect";
import BottomSheet from "../../atoms/bottomSheet/BottomSheet";
import type { SwipeWrapperProps } from "../../atoms/swiper/SwipeWrapper";
import SubNavbar from "../../molecules/navs/SubNavbar";

const DesktopTemplatesWrapper = styled.main<SwipeWrapperProps>`
  display: flex;
  position: relative;
  flex-direction: column;

  overflow: hidden;

  overscroll-behavior: contain;
  overflow-x: hidden;
  /* position: fixed; */
  pointer-events: all;
  width: 100%;
  height: 120%;
  z-index: 95;
  top: 0;
  overflow: scroll;
  overscroll-behavior: contain;
  /* animation: translateYFrom100to70pxAnimation 1s; */

  border-radius: 18px;
  height: calc(100vh - 20px);
  width: 100%;
  ${({ theme }) =>
    theme.layer({
      interactive: false,
      type: "white",
      lightness: "medium",
      border: "light",
    })};

  @media (min-width: 768px) {
    width: 430px;
    border-radius: 18px;
    /* margin: 10px; */
    left: 0;
    /* height: calc(100vh - 20px); */
    margin: 0px;
    border-radius: 0;
    height: var(--h-screen,100vh);
    background-color: white;

    overflow: visible;
    border-right: 1px solid ${({ theme }) => theme.colors.palette["grey-500"]};

    /* animation: translateXFrom30to0pxAnimation 0.5s;
    animation-timing-function: ${({ theme }) => theme.easing.expressive};

    @keyframes translateXFrom30to0pxAnimation {
      0% {
        opacity: 0;
        transform: translateX(50px);
      }

      100% {
        opacity: 1;
        transform: translateY(0px);
      }
    } */
  }
`;

const TemplatesScrollableContentWrapper = styled.div<{ overflow: string }>`
  overflow-y: ${({ overflow }) => overflow};
  overflow-x: visible;
  pointer-events: all;
  height: calc(var(--vh, 100vh) - 30px);
  width: 100%;
  z-index: 0;

  @media (min-width: 768px) {
    height: 100%;
    width: 100%;
    position: relative;
    top: 0;
    overflow: scroll;
  }
`;
interface MainTemplatesLayoutProps {
  header: string;
  mainHeader?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  handleButtonClose: () => void;
  handleButtonBack?: () => void;
  handleButtonEditData?: () => void;
  options: SwipeWrapperProps["options"];
  onScroll?: (event: React.UIEvent) => void;
  initialFocusRef?: React.RefObject<HTMLElement>;
  withSpecialHeader?: boolean;
  closeButtonTooltipLabel?: string;
  shouldSnapToTop?: boolean;
  withHeaderBorder?: boolean;
  showNav?: boolean;
  closeButtonVariant?: string;
  onPositionChange?: (direction: "draggingUp" | "draggingDown") => void;
}

const MainTemplatesLayout: FC<MainTemplatesLayoutProps> = ({
  header,
  mainHeader,
  footer,
  children,
  handleButtonClose,
  withHeaderBorder,
  handleButtonEditData,
  options,
  onScroll,
  initialFocusRef,
  withSpecialHeader,
  closeButtonTooltipLabel,
  shouldSnapToTop,
  showNav = true,
  closeButtonVariant,
  onPositionChange,
}) => {
  const isMobile = useIsMobile();

  const openTo = options?.openTo || "top";
  const [position, setPosition] = React.useState(openTo);
  const getPosition = (p: string, fallback: number) => {
    return typeof options?.positions?.[p] === "number"
      ? options?.positions?.[p]
      : fallback;
  };
  const positions = {
    top: getPosition("top", 10),
    middle: getPosition("middle", 0),
    bottom: getPosition("bottom", window.innerHeight - 160),
  };

  React.useEffect(() => {
    options?.setPosition?.(position);
  }, [position, options?.setPosition]);

  const Nav = () => (
    <SubNavbar
      header={header}
      mainHeader={mainHeader}
      handleButtonClose={handleButtonClose}
      handleButtonEditData={handleButtonEditData}
      withHeaderBorder={withHeaderBorder}
      initialFocusRef={initialFocusRef}
      closeButtonTooltipLabel={closeButtonTooltipLabel}
      closeButtonVariant={closeButtonVariant as "shapeless" | undefined}
    />
  );

  if (isMobile) {
    return (
      <BottomSheet
        options={{
          ...options,
          openTo,
          open: Boolean(options?.open),
          positions,
          expandOnContentDrag: options?.expandOnContentDrag ?? true,
          showHandle: options?.showHandle ?? true,
        }}
        header={showNav ? <Nav /> : <div />}
        footer={footer}
        withSpecialHeader={withSpecialHeader}
        shouldSnapToTop={shouldSnapToTop}
        onPositionChange={onPositionChange}
      >
        {children}
      </BottomSheet>
    );
  }

  return (
    <DesktopTemplatesWrapper>
      {showNav && <Nav />}
      <TemplatesScrollableContentWrapper
        className="hide-scrollbar"
        overflow={position === "top" ? "auto" : "hidden"}
        onScroll={onScroll}
      >
        {children}
      </TemplatesScrollableContentWrapper>
    </DesktopTemplatesWrapper>
  );
};

export default memo(MainTemplatesLayout);
